import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ConsultationOrderDetailsPage from "./detailsPage";

const OrderDetailsModal = ({
  toggle,
  modal,
  activeOrder,
}) => {
  return (
    <>
      <Modal isOpen={modal} toggle={toggle} size="lg" centered>
        <ModalHeader toggle={toggle}>
          Order Details
        </ModalHeader>
        <ModalBody>
          <ConsultationOrderDetailsPage
            activeOrder={activeOrder}
            // reload={handleActiveOrder}
            // getallOrders={getAllOrdersList}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default OrderDetailsModal;
